
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"#FF4368","viewBox":"0 0 22 22"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M11 0C4.935 0 0 4.934 0 11s4.935 11 11 11 11-4.934 11-11S17.065 0 11 0zm0 20.646c-5.319 0-9.646-4.327-9.646-9.646 0-5.319 4.327-9.646 9.646-9.646 5.319 0 9.646 4.327 9.646 9.646 0 5.319-4.327 9.646-9.646 9.646z"}}),_c('path',{attrs:{"d":"M11.175 7.746a1.132 1.132 0 100-2.264 1.132 1.132 0 000 2.264zM11.004 9c.304 0 .55.329.55.734v6.233c0 .405-.246.733-.55.733-.303 0-.55-.328-.55-.733V9.734c0-.405.247-.734.55-.734z"}})])])
          )
        }
      }
    